import HTTPRequest from '../../../controllers/httpRequest.js'
import secureStorage from '../../../controllers/secureStorage';
import reportUtils from '../../../components/reportUtils';
import moment from 'moment';
import { mapState } from 'vuex';
import 'jspdf-autotable';
var printOripox = {
    computed: {
        ...mapState(['profileId']),
    },
    methods: {
        async formatFile(data,inputSite,inputFormat,inputGroupBy,isSeparateSite,isConsider,inputDate) {
            // console.log(inputSite);
            // if(inputDate.length == 0){
            //     reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
            //     return
            // }

            // let sorting = this.inputSortBy
            // if(inputFormat != '1'){
            //     sorting = this.inputSortExtendedBy
            // }

            // this.fileDate = inputDate.format('DD_MM_YYYY_h;mmA');
            // // if no site is selected, send all site IDs under the selected company to fix filter issue on All Site
            // let siteId = inputSite.length > 0 ? inputSite.toString() : this.userSiteCompanyOptions.map(site => site.id).toString();

            // let parameters = {
            //     "site_id": siteId,
            //     "as_of": inputDate.format('YYYY-MM-DD HH:mm:ss'),
            //     "group": inputGroupBy,
            //     "order": sorting,
            //     "by": this.showSortInfo,
            //     "isSeparate": isSeparateSite,
            //     "display": this.inputDisplay,
            //     "isTI": isConsider,
            //     "isFormat": inputFormat,
            //     "isPrev": this.isShowPrev,
            //     "advanced_filter": this.params
            // }
            // let get_request = []
            // if(inputFormat == 4){
            //     get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory_list?', parameters);
            // }
            // else {
            //     get_request = await HTTPRequest.getRequest(this.endPoint + 'general_inventory?', parameters);
            // }

            // if(get_request.error) {
            //     reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
            //     return
            // }

            // test
            let siteSpecific = data;
            // if (get_request.data !=undefined){
            //     siteSpecific = get_request.data;
            // }
            if(siteSpecific.length > 0 && inputFormat != 4){
                let headers = [];
                let header_top = [];
                let site_specific = [];

                if(['1', '5'].includes(inputFormat)){
                    const grouper = inputGroupBy.replace('_id', '').replace(/^\w/, (c) => c.toUpperCase());
                    header_top.push(
                        isSeparateSite ? 'Site' : grouper,                            
                        'Barcode',
                        // 'Stock #',
                        // 'Ref Code',
                        'Description',
                        'Brand',
                        'Good',
                        'Damaged',
                        'Reserved',
                        'Losses',
                        'Disposal',
                        'Total On-hand Qty',
                        // 'On-Hand',
                        'In-transit Qty',
                        'Total Qty',
                        'Unit Price',
                        'Total Price'
                    )
                    headers = header_top
                } else {
                    header_top.push(
                        // 'PCode',
                        'Barcode',
                        // 'Stock #',
                        'Description',
                        'On-Hand',
                        'In-transit',
                        'Incoming',
                        'Outgoing',
                        'Available'
                    )

                    if(inputFormat == '3'){
                        header_top.push('# of day/s\nsince last sale')
                    }

                    if(isConsider == true){
                        header_top.push('Last Arrival (RR/STI Document) - Date','Last Arrival (RR/STI Document) - Quantity','Last Arrival (RR/STI Document) - Cost')
                    }else{
                      header_top.push('Last Arrival (RR Document) - Date','Last Arrival (RR Document) - Quantity','Last Arrival (RR Document) - Cost')
                    }

                    headers = header_top
                }

                // console.log("-------------------")
                let grand_grand_total = 0
                for (let x=0; x < siteSpecific.length; x++){
                    // console.log("siteSpecific",siteSpecific);
                    this.birSalesReports = siteSpecific[x].report_details

                    let reportData = [];
                    if(this.birSalesReports.length > 0){
                        let grouper = 'start'

                        let total_onhand_qty = 0
                        let total_in_qty = 0
                        let total_out_qty = 0
                        let total_rr_qty = 0
                        let total_rr_cost = 0
                        let total_available = 0
                        let total_intransit_qty = 0

                        let grand_onhand_qty = 0
                        let grand_in_qty = 0
                        let grand_out_qty = 0
                        let grand_rr_qty = 0
                        let grand_rr_cost = 0
                        let grand_available = 0
                        let grand_intransit_qty = 0

                        let grand_good_qty = 0
                        let grand_damaged_qty = 0
                        let grand_disposal_qty = 0
                        let grand_losses_qty = 0
                        let grand_reserved_qty = 0
                        let total_good_qty = 0
                        let total_damaged_qty = 0
                        let total_disposal_qty = 0
                        let total_losses_qty = 0
                        let total_reserved_qty = 0

                        for(let i=0; i < this.birSalesReports.length; i++){
                            let reportLine = this.birSalesReports[i]
                            if (reportLine.barcode == "NS1000489934"){
                                console.log(reportLine)
                            }
                            let grouper_name = reportLine.grouper_name

                            // Accumulate the total on-hand quantity (including good, damaged, reserved, losses)
                            totalOnHandQty += temp_onhand_qty

                            if(grouper == 'start' && !['5', '6'].includes(inputFormat)){
                                let detail_header = [grouper_name];
                                reportData.push(detail_header)
                            } else {
                                if(grouper != reportLine.grouper_name && !['5', '6'].includes(inputFormat)){
                                    let detail_header = [grouper_name]
                                    reportData.push(detail_header)
                                }
                            }
                            if(['5', '6'].includes(inputFormat)){
                                grouper = 'start'
                            } else {
                                grouper = reportLine.grouper_name
                            }

                            let as_of_date = moment(inputDate,'YYYY-MM-DD')

                            let no_days_display = ''
                            if(reportLine.sales_date != null){
                                let no_days = this.diffDays(reportLine.sales_date, as_of_date)
                                no_days_display = this.formatNumber(Number(no_days))
                            }

                            let rr_date = ''
                            let rr_qty = ''
                            let rr_cost = ''
                            if(reportLine.rr_date != null){
                                rr_date = reportLine.rr_date
                                rr_qty = this.qtyFormatter(reportLine.rr_qty)
                                rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                            }
                            let available = Number(reportLine.onhand_qty) - Number(reportLine.out_qty)

                            let detail = [
                                // reportLine.product_id,
                                reportLine.site_name,
                                reportLine.barcode,
                                // reportLine.stock_no
                            ]
                            // if(['1', '5'].includes(inputFormat)){
                            //     detail.push(reportLine.reference_code)
                            // }
                            var plus_onhand =  (Number(reportLine.good_onhand) || 0) + 
                                    (Number(reportLine.damaged_onhand) || 0) + 
                                    (Number(reportLine.reserved_onhand) || 0) + 
                                    (Number(reportLine.losses_onhand) || 0) + 
                                    (Number(reportLine.disposal_onhand) || 0)
                            var temp_onhand_qty = (Number(reportLine.good_onhand) || 0) + 
                            (Number(reportLine.damaged_onhand) || 0) + 
                            (Number(reportLine.reserved_onhand) || 0) + 
                            (Number(reportLine.losses_onhand) || 0) + 
                            (Number(reportLine.disposal_onhand) || 0) || Number(reportLine.onhand_qty)
                            if(plus_onhand < reportLine.onhand_qty && inputSite.length > 1){
                                temp_onhand_qty = Number(reportLine.onhand_qty)
                            }
                            if (plus_onhand <= 0 && Number(reportLine.onhand_qty) > 0){
                                temp_onhand_qty = Number(reportLine.onhand_qty)
                            }
                            detail.push(
                                reportLine.name,
                                reportLine.brand_name,
                                this.qtyFormatter(reportLine.good_onhand),
                                this.qtyFormatter(reportLine.damaged_onhand),
                                this.qtyFormatter(reportLine.reserved_onhand),
                                this.qtyFormatter(reportLine.losses_onhand),
                                this.qtyFormatter(reportLine.disposal_onhand),
                                // this.qtyFormatter(reportLine.onhand_qty),
                                this.qtyFormatter(
                                    temp_onhand_qty
                                ),
                                this.qtyFormatter(reportLine.intransit_qty),
                                this.qtyFormatter(
                                    temp_onhand_qty +
                                    (Number(reportLine.intransit_qty) || 0)
                                ),
                                reportLine.price,
                                this.qtyFormatter(
                                    temp_onhand_qty * 
                                    (Number(reportLine.price) || 0)
                                )
                            )

                            if(inputFormat != '1'){
                                detail.push(
                                    this.qtyFormatter(reportLine.intransit_qty),
                                    this.qtyFormatter(reportLine.in_qty),
                                    this.qtyFormatter(reportLine.out_qty),
                                    this.qtyFormatter(available)
                                )
                            }
                            if(inputFormat == '3'){
                                detail.push(no_days_display)
                            }
                            if(inputFormat != '1'){
                                detail.push(rr_date, rr_qty, this.addMaskValidation(rr_cost), 'Z')
                            }
                            reportData.push(detail)

                            total_onhand_qty += Number(reportLine.onhand_qty)
                            grand_onhand_qty += Number(temp_onhand_qty)
                            grand_grand_total += Number(temp_onhand_qty +
                            (Number(reportLine.intransit_qty) || 0))
                            total_good_qty += Number(reportLine.good_onhand)
                            total_damaged_qty += Number(reportLine.damaged_onhand)
                            total_disposal_qty += Number(reportLine.disposal_onhand)
                            total_losses_qty += Number(reportLine.losses_onhand)
                            total_reserved_qty += Number(reportLine.reserved_onhand)

                            grand_good_qty += Number(reportLine.good_onhand)
                            grand_damaged_qty += Number(reportLine.damaged_onhand)
                            grand_disposal_qty += Number(reportLine.disposal_onhand)
                            grand_losses_qty += Number(reportLine.losses_onhand)
                            grand_reserved_qty += Number(reportLine.reserved_onhand)
                            total_intransit_qty += Number(reportLine.intransit_qty)

                            if(inputFormat != '1'){
                                total_intransit_qty += Number(reportLine.intransit_qty)
                                total_in_qty += Number(reportLine.in_qty)
                                total_out_qty += Number(reportLine.out_qty)
                                total_available += available
                                total_rr_qty += Number(reportLine.rr_qty)
                                total_rr_cost += Number(reportLine.rr_cost)

                                grand_intransit_qty += Number(reportLine.intransit_qty)
                                grand_in_qty += Number(reportLine.in_qty)
                                grand_out_qty += Number(reportLine.out_qty)
                                grand_available += available
                                grand_rr_qty += Number(reportLine.rr_qty)
                                grand_rr_cost += Number(reportLine.rr_cost)
                            }

                            // Add the row for the "Sub Total"
                            let totalOnHandQty = 0;
                            totalOnHandQty += temp_onhand_qty

                            if(i == this.birSalesReports.length-1){
                                let sub_detail = ['', '', '']
                                let grand_detail = ['', '', '']
                                let subTotalDetail = ['', '']
                                if(['1', '5'].includes(inputFormat)){
                                    subTotalDetail.push(
                                        'Sub Total :',
                                        '',
                                        '',
                                        '',
                                        '',
                                        '',
                                        this.qtyFormatter(totalOnHandQty), // Display the total on-hand quantity for all rows
                                    )
                                }else{
                                    grand_detail.push(
                                        'Grand Total :',
                                        this.qtyFormatter(grand_onhand_qty)
                                    )
                                }
                                if(inputFormat != '1'){
                                    sub_detail.push(
                                        this.qtyFormatter(total_intransit_qty),
                                        this.qtyFormatter(total_in_qty),
                                        this.qtyFormatter(total_out_qty),
                                        this.qtyFormatter(total_available)
                                    )
                                }
                                if(inputFormat == '3'){
                                    sub_detail.push('')
                                    grand_detail.push('')
                                }
                                if(inputFormat != '1'){
                                    sub_detail.push('', this.qtyFormatter(total_rr_qty), this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'))
                                    grand_detail.push('', this.qtyFormatter(grand_rr_qty), this.addMaskValidation(this.convertToCurrency(grand_rr_cost), 'Z'))
                                }
                                if(!['5', '6'].includes(inputFormat)){
                                    reportData.push(["---"])
                                    reportData.push(sub_detail)
                                }
                            } else {
                                let current_grouper = reportLine.grouper_id
                                let next_grouper = this.birSalesReports[i+1].grouper_id

                                if(current_grouper != next_grouper){
                                    let sub_detail = ['', '', '']
                                    if(inputFormat != '1'){
                                        sub_detail.push(
                                            this.qtyFormatter(total_intransit_qty),
                                            this.qtyFormatter(total_in_qty),
                                            this.qtyFormatter(total_out_qty),
                                            this.qtyFormatter(total_available)
                                        )
                                    }
                                    if(inputFormat == '3'){
                                        sub_detail.push('')
                                    }
                                    if(inputFormat != '1'){
                                        sub_detail.push('', this.qtyFormatter(total_rr_qty), this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'))
                                    }
                                    if(!['5', '6'].includes(inputFormat)){
                                        reportData.push(["-----"])

                                        if (isSeparateSite == true) {
                                            reportData.push(["Site: " + siteSpecific[x].report_details[0].site_name]);
                                        }

                                        // Remove extas space on row
                                        if (sub_detail && typeof sub_detail === 'string' && sub_detail.trim() !== '') {
                                            reportData.push(sub_detail);
                                        }
                                    }

                                    total_intransit_qty = 0
                                    total_onhand_qty = 0
                                    total_in_qty = 0
                                    total_out_qty = 0
                                    total_available = 0
                                    total_rr_qty = 0
                                    total_rr_cost = 0
                                    total_good_qty = 0
                                    total_damaged_qty = 0
                                    total_disposal_qty = 0
                                    total_losses_qty = 0
                                    total_reserved_qty = 0
                                }
                            }
                        }
                    }

                    let group_text = ""
                    if(inputGroupBy != ''){
                        group_text = " by " + inputGroupBy.slice(0, -3)
                    }
                    if (['1', '2', '3', '5', '6'].includes(inputFormat) && x === siteSpecific.length - 1) {
                        if (inputFormat =='1'){
                            reportData.push(
                                ['','','','','','','','','','',
                                'Grand Total :',
                                this.qtyFormatter(grand_grand_total)]
                            )
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(['', '', '', '', ''])
                        reportData.push(["General Inventory Report (Advance)" + group_text, "Printed By: " + printed_by,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])

                        console.log("checkpoint: inside condition")
                    }
                    let keys = headers;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                  [val]: values[i][index]
                              }
                          )
                        )
                      );
                      newJsonData.push(result)
                    }

                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                      for(var i in obj) {
                        if(obj[i] === undefined || obj[i] === null ) {
                          obj[i] = '';
                        }
                      }
                    });
                    site_specific.push(newJsonData)

                    // this.JsonData = site_specific;
                                    }
                // for each site specific[] convert nested to single array
                return site_specific.flat(Infinity);
            } else if(inputFormat == 4){
                let headers = [];
                let header_top = [];
                let site_specific = [];

                header_top.push('PRODUCT / INVENTORY CODE','ITEM DESCRIPTION','ADDRESS','CODE','REMARKS','INVENTORY VALUATION METHOD', 'UNIT PRICE', 'QUANTITY IN STOCKS', 'UNIT OF MEASUREMENT', 'TOTAL WEIGHT / VOLUME', 'TOTAL COST')
                headers = header_top


                // console.log("-------------------")
                for (let x=0; x < siteSpecific.length; x++){
                    this.birSalesReports = siteSpecific[x].report_details

                    let reportData = [];
                    let total_onhand_qty = 0;
                    let ttl_cost = 0;
                    let grand_onhand_qty = 0;
                    let grand_cost = 0;
                    let group_pid = 0
                    let ttl_cost_per_pid = 0
                    for(let i=0; i < this.birSalesReports.length; i++){
                        let line = this.birSalesReports[i];
                        if (group_pid == line.product_id){
                            ttl_cost_per_pid += Number(line.total_cost)
                        }
                        if (group_pid > 0 && group_pid != line.product_id){
                            if (this.birSalesReports[i-1].code == "CH" && i > 1){
                                if (group_pid == this.birSalesReports[i-2].product_id && this.birSalesReports[i-2].code != "CH"){
                                    this.birSalesReports[i-2].sum_ttl_cost = ttl_cost_per_pid
                                }
                            }else{
                                this.birSalesReports[i-1].sum_ttl_cost = ttl_cost_per_pid
                            }
                            group_pid = line.product_id
                            ttl_cost_per_pid = 0
                            if (group_pid == line.product_id){
                                ttl_cost_per_pid += Number(line.total_cost)
                            }
                        }
                        if (group_pid == line.product_id && (i+1) == this.birSalesReports.length){
                            if (this.birSalesReports[i].code != "CH"){
                                this.birSalesReports[i].sum_ttl_cost = ttl_cost_per_pid
                            }
                        }
                        group_pid = line.product_id
                    }
                    for(let i=0; i < this.birSalesReports.length; i++){
                        let reportLine = this.birSalesReports[i];
                        if (reportLine.sum_ttl_cost != undefined && reportLine.sum_ttl_cost > 0){
                            var cost_discrepancy = Number(reportLine.inventory_cost_total) - Number(reportLine.sum_ttl_cost)
                            if (cost_discrepancy != 0 && reportLine.code !='CH'){
                                reportLine.total_cost = Number(reportLine.total_cost) + Number(cost_discrepancy)
                            }
                        }
                        let as_of_date = inputDate.format('YYYY-MM-DD')

                        let no_days_display = ''
                        if(reportLine.sales_date != null){
                            let no_days = this.diffDays(reportLine.sales_date, as_of_date)
                            no_days_display = this.formatNumber(Number(no_days))
                        }

                        let rr_date = ''
                        let rr_qty = ''
                        let rr_cost = ''
                        if(reportLine.rr_date != null){
                            rr_date = reportLine.rr_date
                            rr_qty = this.qtyFormatter(reportLine.rr_qty)
                            rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                        }
                        let available = Number(reportLine.onhand_qty) - Number(reportLine.out_qty)
                        var temp_ttl_cost = (Number(reportLine.total_cost) == 0 && Number(reportLine.onhand_qty)!=0 && reportLine.code!="CH") ? reportLine.sum_ttl_cost : reportLine.total_cost 
                        let detail = [
                            reportLine.barcode,
                            reportLine.name,
                            reportLine.site_name,
                            reportLine.code,
                            '',
                            'Weighted Average',
                            this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Z'),
                            this.qtyFormatter(reportLine.onhand_qty),
                            (reportLine.reference_code != null) ? reportLine.reference_code.split("-")[1] : '',
                            '',
                            this.addMaskValidation(this.convertToCurrency(Number(temp_ttl_cost)), 'Z')
                        ]
                        reportData.push(detail)

                        total_onhand_qty += Number(reportLine.onhand_qty)
                        grand_onhand_qty += Number(reportLine.onhand_qty)
                        ttl_cost += Number(reportLine.onhand_qty * reportLine.cost)
                        // grand_cost += Number(reportLine.onhand_qty * reportLine.cost)
                        grand_cost += Number(reportLine.total_cost);

                    }

                    let group_text = ""
                    if(inputGroupBy != ''){
                        group_text = " by " + this.groupOptions.find(x => x.key === inputGroupBy).value
                    }

                    if(isSeparateSite == true){
                    } else {
                        let site_text = ''
                        if(inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        reportData.unshift([site_text]);
                    }

                    // only add legends and report header details on the footer once at the end of the reportt
                    if (inputFormat != '1' && x === siteSpecific.length - 1) {
                        var legends = [
                            'CH = Goods on consignment held by the taxpayer',
                            'P = Parked goods or goods owned by related parties',
                            'O = Goods owned by the taxpayer',
                            'CO = Goods out on consignment held in the hands of entity other than taxpayer'
                        ];

                        reportData.push(['', '', '', '', '']);
                        reportData.push(['Note 1', 'a. Include all goods whether taxpayer has title thereto or not, provided these goods are actually situated in location/address at the Head Office or Branch or Facilities (with or without sales activity of the taxpayer). Facilities']);
                        reportData.push(['', 'shall include but not limited to place of production, showroom, warehouse, storage place, leased property, etc. Include also goods out on consignment, though not physically present are nonetheless owned by the taxpayer.']);
                        reportData.push(['', '', '', '', '']);
                        reportData = reportUtils.csvxlsxTools.addLegendForInventoryListReport(reportData, legends);
                        reportData.push(['', '', '', '', '']);
                        reportData.push(['Note 2', 'Indicate Costing Method applied, e.g., Standard Costing, FIFO, Weighted Average, Specific Identification, etc.']);
                        reportData.push(['', '', '', '', '']);
                        reportData.push(['', '', 'We declare, under the penalties of perjury, that this schedule has been made in good faith, verified by us, and to the best of our knowledge and belief, is true and correct pursuant to the provisions of the National Internal ']);
                        reportData.push(['', '', 'Revenue Code, as amended, and the regulations issued under authority thereof.']);
                        reportData.push(['', '', '', '', '']);
                        reportData.push(['', '', '', '', '', '', '______________________________________________________________________']);
                        reportData.push(['', '', '', '', '', '', '', '', '   Name and Signature of Authorized']);
                        reportData.push(['', '', '', '', '', '', '', '', '', 'Representative']);
                        reportData.push(['', '', '', '', '', '', 'TIN: __________________']);

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(['', '', '', '', ''])
                        reportData.push(["General Inventory Report (Advance)" + group_text, "Printed By: " + printed_by,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])
                    }

                    let keys = headers;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i = 0; i < values_length; i++){
                        var result = Object.assign.apply({}, keys.map( (val, index) => ({
                            [val]: values[i][index]
                        })));
                        newJsonData.push(result)
                    }

                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null) {
                                obj[i] = '';
                            }
                        }
                    });
                    site_specific.push(newJsonData)

                }
                // for each site specific[] convert nested to single array
                return site_specific.flat(Infinity);
            } else {
                this.$notification["error"]({
                    message: 'Export Error',
                    description: "No Data."
                });
            }
        },
        formatNumber(num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
         },
         diffDays(date1, date2){
            let a = moment(date1,'YYYY-MM-DD');
            let b = moment(date2,'YYYY-MM-DD');
            return b.diff(a, 'days');
        },
        convertToCurrency(num){
            return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        qtyFormatter(num){
            return Number(num).toLocaleString();
        },
        addMaskValidation(value, rights){
            var accessCostPriceRights = []
            if((!accessCostPriceRights.includes('Z') && rights == 'Z') || (!accessCostPriceRights.includes('Y') && rights == 'Y')){
                return '***';
            }else{
                return value
            }
        },
    }
}

export default printOripox;